import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../global/global.service';
import { environment } from '../../environments/environment';


@Injectable()
export class AllService {
  constructor(private http: HttpClient, private globalService: GlobalService) { }

  token = this.globalService.getToken();
  urlContaE = this.globalService.urlContaE();
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.globalService.getBearerToken());
  urlSSO = environment.LoginURL;//-/app/sso
  // Servicios Conta E

  // Lambdas

  public LambdaClient(FunctionName, Params): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      FunctionName: FunctionName,
      Params: JSON.stringify(Params)
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Lambda/LambdaClient', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // Documents

  public invoiceListStatus(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Status_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceListActions(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Actions_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public DocTypeList(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Document_Type_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Invoice_DateFilterType_List(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_DateFilterType_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Invoice_Range_List(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Range_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public InvoicesChartsInfo(idCompany, dateRange, typeInvoice, moneda, idRepositoryType, statusReconciled): Observable<any> {
    const obj = {
      idCompany: idCompany,
      dateRange: dateRange,
      typeInvoice: typeInvoice,
      moneda: moneda,
      idRepositoryType: idRepositoryType,
      statusReconciled: statusReconciled,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/KPI/InvoicesChartsInfo', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Folios_Breakdown(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/KPI/Folios_Breakdown', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceList(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // public invoicePagination(obj): Observable<any> {
  //   obj.UserToken = this.globalService.getToken();
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(
  //     this.urlContaE + 'api/Invoice/Invoice_Pagination', json, { headers: this.headers })
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error);
  //     });
  // }

  public invoiceChangeVis(Status, IdFacturaList): Observable<any> {
    const obj = {
      Status: Status,
      IdFacturaList: IdFacturaList,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Change_Visibility', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // public invoiceDownloadZip(IdFacturaList) {
  //   const obj = {
  //     UserToken: this.globalService.getToken(),
  //     IdFacturaList: IdFacturaList
  //   };
  //   return this.urlContaE + 'api/Invoice/Invoice_DownLoad_Zip?UserToken=' + this.globalService.getToken() + '&IdFacturaList=' + IdFacturaList;

  // }

  public invoiceDownloadZip(obj): Observable<any> {
    const json = JSON.stringify(obj);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    return this.http
      .post<Blob>(this.urlContaE + 'api/Invoice/Invoice_DownLoad_Zip', json, { headers: headers, responseType: 'blob' as 'json' })
  }

  // public invoiceDownloadZip(IdFacturaList): Observable<any> {
  //   // const obj = {
  //   //   UserToken: this.globalService.getToken(),
  //   //   IdFacturaList: IdFacturaList
  //   // };
  //   // const json = JSON.stringify(obj);
  //   return this.http.get(
  //     this.urlContaE + 'api/Invoice/Invoice_DownLoad_Zip2?UserToken='+this.globalService.getToken()+'&IdFacturaList=1,2')
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error);
  //     });
  // }

  public invoiceDelete(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceChangeStatusFromReonciledToPeding(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Change_Status_From_Reconciled_To_Pending', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceValidate(IdFacturaList, isIncome): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      isIncome: isIncome,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_ReValidate', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceValidateEfos(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_ReValidate_Efos', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceReconcilliedWeb(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Reconciled_Web_Level', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceUnReconciledWeb(IdFacturaList): Observable<any> {
    const obj = {
      IdFacturaList: IdFacturaList,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_UnReconciled_Web_Level', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoicePreconciledList(IdFactura): Observable<any> {
    const obj = {
      IdFactura: IdFactura,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Preconciled_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceDetailList(IdDocument): Observable<any> {
    const obj = {
      IdDocument: IdDocument,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Detail_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoicePriorityChange(IdDocument): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      IdDocument: IdDocument
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Document_Priority_Change', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public companyList(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Company_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public statusReconciledList(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Status_Reconciled_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public invoiceById(IdFactura): Observable<any> {
    const obj = {
      IdFactura: IdFactura,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_By_Id', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // public GenerateCFDIprintRepresentation(documents): Observable<any> {
  //   const obj = {
  //     documents: documents,
  //     UserToken: this.globalService.getToken()
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(
  //     this.urlContaE + 'api/Invoice/GenerateCFDIprintRepresentation', json, { headers: this.headers })
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error);
  //     });
  // }

  public invoiceDocStsSecond(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Invoice_Document_Second_Type_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public documentPreconciledList(IdFactura): Observable<any> {
    const obj = {
      IdFactura: IdFactura,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Preconciled_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }
  // GS 04/01/2023
  public documentPreconciledList_EGastos(IdFactura): Observable<any> {
    const obj = {
      IdFactura: IdFactura,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Preconciled_List_EGastos', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public documentDetailList(IdDocument): Observable<any> {
    const obj = {
      IdDocument: IdDocument,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Documents_Detail_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public documentPriorityChange(IdDocument): Observable<any> {
    const obj = {
      IdDocument: IdDocument,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Document_Priority_Change', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersByRFC(Rfc): Observable<any> {
    const obj = {
      Rfc: Rfc,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_By_Rfc_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersInvoiceById(Id_Invoice): Observable<any> {
    const obj = {
      Id_Invoice: Id_Invoice,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_Invoice_By_Id', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersDocEdit(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_Document_New_Edit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public parametersInvoiceEdit(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Parameters_Invoice_Edit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // Repositories

  public getRepositories(SearchKey, Page): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      SearchKey: SearchKey,
      Page: Page
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Email_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public newEditRepository(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Email_NewEdit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public getRepositoryById(Id_Repository): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Repository: Id_Repository
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Email_ById', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public getListType(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Email_Server_Type', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public updateRepositoryStatus(Id_Repository_Email, IsActive): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      IsActive: IsActive,
      Id_Repository_Email: Id_Repository_Email
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Update_Status', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public repositoryValidated(Id_Repository_Email): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Repository: Id_Repository_Email
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Repository/Repository_Validation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public invoiceLogList(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Log_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  // public invoiceLogPagination(obj): Observable<any> {
  //   obj.UserToken = this.globalService.getToken();
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Log_Pagination', json, { headers: this.headers })
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  public rulesComboList(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Rules_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public statusLogComboList(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Status_Log_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public repositoryTypeComboList(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Repository_Type_Combo_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public invoiceLogByRequestToken(TransacToken): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      TransacToken: TransacToken
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Log_By_Request_Token', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public notificationTypeByRfcList(Rfc): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Rfc: Rfc
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Notification_Type_By_Rfc_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public notificationTypeNewEdit(Receptor_Rfc, Notification_Type): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Receptor_Rfc: Receptor_Rfc,
      Notification_Type: Notification_Type
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Notification_Type_New_Edit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public efosList(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Efos_Type_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public efosByRFCList(RFC): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      List: RFC
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/EFOS/CFDI_GET_EFOS_BY_RFC_LIST', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Efos_Edos_List(SearchKey, Pagination, Page): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      SearchKey: SearchKey,
      Pagination: Pagination,
      Page: Page
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/EFOS/Efos_Edos_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  // public uploadFiles(): Observable<any> {
  //   const obj = {
  //     UserToken: this.globalService.getToken()
  //     XML_File
  //     XML_Name
  //     PDF_File
  //     PDF_File
  //     TransacToken
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Validate', json, {headers: this.headers})
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  uploadFiles(transacToken, filePDF, fileXML): Observable<any> {
    const urlContaE = this.globalService.urlContaE();
    const userToken = localStorage.getItem('key');
    const formData = new FormData();
    formData.append('XML_File', fileXML.files[0]);
    if (filePDF !== undefined && filePDF.files[0] !== undefined) {
      formData.append('PDF_File', filePDF.files[0]);
    }
    // tslint:disable-next-line:max-line-length
    return this.http.post(urlContaE + 'api/Invoice/Invoice_Validate?UserToken=' + userToken + '&TransacToken=' + transacToken, formData);
  }


  // Servicios MiPortal


  public getUserByToken(): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 8,
      data: {
      }
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=User/User_By_Token', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public getSidebar(): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 32,
      data: {
        Id_Tag: 8,
        AppToken: environment.AppToken
      }
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Home/Granted_Menu_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public logout(): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 33,
      data: {
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Home/Logoff', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public notificationType(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Provider/Notification_Type', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  // Servicio Consultar EFOS

  public efosByRFCFree(RFC): Observable<any> {
    //      UserToken: this.globalService.getToken(),
    const obj = {
      RFC: RFC
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/EFOS/CFDI_GET_EFOS_BY_RFC_LIST_FREE', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public document_Free_Lst(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Document_Free_Lst', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public currency_Cache(RFC, CFDI_Currency, SAP_Currency): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      RFC: RFC,
      CFDI_Currency: CFDI_Currency,
      SAP_Currency: SAP_Currency
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Currency_Cache', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public currency_Lst(RFC, CFDI_Currency): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      RFC: RFC,
      CFDI_Currency: CFDI_Currency
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/Currency_Lst', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public cFDI_DocSAP_Conciliation(Id_Invoice, Id_Document): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Invoice: Id_Invoice,
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/CFDI_DocSAP_Conciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public cFDI_DocSAP_DesConciliation(Id_Invoice, Id_Document): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Invoice: Id_Invoice,
      Id_Document: Id_Document
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Invoice/CFDI_DocSAP_DesConciliation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public getFilesSATF(Id_Company): Observable<any> {
    const obj = {
      entidad: "Company",
      funcion: 2,
      data: {
        Id_Company: Id_Company
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Company/Company_EFSign_ById', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  // public getFilesSATFNew(Id_Company, Password, Certificate, Key): Observable<any> {
  //   const obj = {
  //     UserToken: localStorage.getItem('key'),
  //     Id_Company: Id_Company,
  //     Password: Password,
  //     Certificate: Certificate,
  //     Key: Key
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(
  //     this.urlSSO + 'Company/Company_EFSign_NewEdit', json, { headers: this.headers })
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  public SATConfirmTermsSendMail(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'Signature/Company_EFConfirmTerms_SendMail ', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public EFOS_EDOS_Report(Id_Efos_Edos) {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Efos_Edos: Id_Efos_Edos
    };
    return this.urlContaE + 'api/EFOS/Reports_DownLoad_Zip?UserToken=' + this.globalService.getToken() + '&IdEfos_EdosList=' + Id_Efos_Edos;

  }

  public Company_SATDownloadEdit(Id_Company, Status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Status: Status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'Signature/Company_SATDownloadEdit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Service_Detail(Id_Service): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Service: Id_Service,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Services/Service_Detail', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Service_Prices(Id_Service): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Service: Id_Service,
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Services/Service_Prices', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Service_Register(Id_Service, automaticRenewal): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Service: Id_Service,
      automaticRenewal: automaticRenewal
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Services/Service_Register', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Company_EFSign_Delete(Id_Company): Observable<any> {

    const obj = {
      Id_Company: Id_Company
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'Signature/Company_EFSign_Delete', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Service_ActiveEdit(Id_Service_Customer, Status): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Service_Customer: Id_Service_Customer,
      Status: Status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Services/Service_ActiveEdit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }


  public ProcessReport(Id_Fiscal_Report_Request, idReport): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Fiscal_Report_Request: Id_Fiscal_Report_Request,
      Report: idReport
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/FiscalReport/ProcessReport', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public processReportIsr(idRequest, jsonData?): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Fiscal_Report_Request: idRequest,
      JSONExternalData: jsonData
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/FiscalReport/ProcessReportJson', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  // public Service_RenewalEdit(Id_Service_Customer, AutomaticRenewal): Observable<any> {
  //   Renovación automatica
  //   const obj = {
  //     UserToken: this.globalService.getToken(),
  //     Id_Service_Customer: Id_Service_Customer,
  //     AutomaticRenewal: AutomaticRenewal
  //   };
  //   const json = JSON.stringify(obj);
  //   return this.http.post<any>(this.urlContaE + 'api/Services/Service_RenewalEdit', json, { headers: this.headers })
  //     .catch(error => {
  //       return Observable.throw('An error occurred:', error.error.message);
  //     });
  // }

  public Service_CancelEdit(Id_Service_Customer, Cancelled): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      Id_Service_Customer: Id_Service_Customer,
      Cancelled: Cancelled
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Services/Service_CancelEdit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public InvoicesChartsCurrenncies(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/KPI/InvoicesChartsCurrencies', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public InvoicesChartsSources(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/KPI/InvoicesChartsSources', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public InvoicesChartsStatus(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/KPI/InvoicesChartsStatus', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }


  // Boveda Fiscal


  public Vault_Documents_List(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Vault_Documents_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Vault_Date_Filter_List(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Vault_Date_Filter_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }


  public Vault_Upload_PDF(Id_Invoice, PDF_File): Observable<any> {
    const UserToken = localStorage.getItem('key');
    const formData = new FormData();

    if (PDF_File !== undefined && PDF_File.files[0] !== undefined) {
      formData.append('PDF_File', PDF_File.files[0]);
    }

    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/Vault_Upload_PDF?UserToken=' + UserToken + '&Id_Invoice=' + Id_Invoice, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Estado de cuenta

  public Account_Statement_Customer_List(Id_Application, Year, Status): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 80,
      data: {
        Id_Application: Id_Application,
        Year: Year,
        Status: Status
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Account_Statement/Account_Statement_Customer_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Account_Statement_Customer_Year_List(): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 82,
      data: {
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Account_Statement/Account_Statement_Customer_Year_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Pay_Status_Account_Statemen(): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 84,
      data: {
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Account_Statement/Pay_Status_Account_Statemen', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // Kardex de Folios

  public registerTypeFoliosCombo(): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 48,
      data: {
        Access_Key: "N"
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Customer/Kardex_Folios_Register_Type_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }


  public dateFoliosCombo(): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 49,
      data: {
        Access_Key: "N"
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Customer/Kardex_Folios_Date_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public maintenanceFoliosList(properties): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 50,
      data: {
        Access_Key: "N",
        Id_Application: properties.Id_Application,
        Id_Company: properties.Id_Company,
        Page: properties.Page_Number,
        Page_Number: properties.Page_Number,
        Pagination: properties.Pagination,
        Register_Type: properties.Register_Type,
        dateFilter: properties.dateFilter,
        ElementsByPage: properties.elementsByPage,
        idCompany: properties.idCompany
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Customer/Kardex_Folios_Main_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public maintenanceResumeFoliosList(Id_Company): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 52,
      data: {
        Id_Company: Id_Company,
        Access_Key: "N"
      }
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Customer/Kardex_Folios_Resume_Main_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Kardex_Folios_Company_List(): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 46,
      data: {
        Access_Key: "N"
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Customer/Kardex_Folios_Company_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }


  // Servicios Nuevos Proveedores

  public getCompanyAll(): Observable<any> {
    const obj = {
      entidad: "Company",
      funcion: 90,
      data: {
      }
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Company/Company_List_All', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }


  public getProviderById(Id_Provider): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Provider: Id_Provider
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Provider/Provider_ById', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public getListProviders(SearchKey, Id_Company, Page, Id_Customer, Risk_Level, Type, Change_Of_Status): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      SearchKey: SearchKey,
      Id_Company: Id_Company,
      Page: Page,
      Id_Customer: Id_Customer,
      Risk_Level: Risk_Level,
      Type: Type,
      Change_Of_Status: Change_Of_Status
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Provider/Provider_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Mark_Alert_As_View(Rfc): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Rfc: Rfc
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Provider/Mark_Alert_As_View', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Provider_By_EFOS_EDOS(Id_Company, Type, Efos_Edos_Type = '*', SearchKey = ''): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: Id_Company,
      Type: Type,
      Efos_Edos_Type: Efos_Edos_Type,
      SearchKey: SearchKey
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Provider/Provider_By_EFOS_EDOS', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }


  public newEditProviders(obj): Observable<any> {
    obj.UserToken = localStorage.getItem('key'); //token
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Provider/Provider_NewEdit', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }


  public getCustomerID(): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 8,
      data: {
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlSSO + 'app/sso?d=Customer/Customer_By_Token', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public getCustomerListAll(): Observable<any> {
    const obj = {
      entidad: "Customer",
      funcion: 1,
      data: {
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Customer/Customer_List_All', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public providerListDown(Id_Customer): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Access_Key: 'MPX_SLCORG',
      Access_Key_DownLoad: 'MPX_SLDLPVR',
      Id_Customer: Id_Customer
    };
    const json = JSON.stringify(obj);

    return this.http.post<any>(this.urlContaE + 'api/Provider/Provider_List_DownLoad', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }


  public getAccessPermit(KeyAccess): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 20,
      data: {
        KeyAccess: KeyAccess
      }
    };

    const json = JSON.stringify(obj);
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(this.urlSSO + 'app/sso?d=User/User_Access', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Det_Efos_Edos_By_RFC(RFC): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken(),
      RFC: RFC
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/EFOS/Det_Efos_Edos_By_RFC', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }


  // Servicios Documentos SAP

  public Types_Document(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Documents/Types_Document', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Currencies_Document(): Observable<any> {
    const obj = {
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Documents/Currencies_Document', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Document_List(obj): Observable<any> {
    obj.UserToken = this.globalService.getToken();
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Documents/Document_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // Limitar servicio SAT

  public User_Access(KeyAccess): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 20,
      data: {
        KeyAccess: KeyAccess
      }
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlSSO + 'app/sso?d=User/User_Access', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  // Servicio Parametros

  public get_Parameters_List(RFC_Company, Group_Param): Observable<any> {
    const obj = {
      RFC_Company: RFC_Company,
      Group_Param: Group_Param,
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Get_Parameters_List', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public update_Parameter_By_Id(RFC_Company, Id_Parameter, Value): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      RFC_Company: RFC_Company,
      Id_Parameter: Id_Parameter,
      Value: Value
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Parameters/Update_Parameter_By_Id', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public FoliosCoverageDays(idCompany): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Company: idCompany
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/KPI/FoliosCoverageDays', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public modelContaFiscal(entidad, funcion, data): Observable<any> {
    const obj = {
      entidad,
      funcion,
      data
    };
    // this.headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   UserToken: localStorage.getItem('key'),
    // });


    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.globalService.getBearerToken())
      .set('UserToken', localStorage.getItem('key'));

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'contae/model', json, { headers: this.headers });
  }

  public modelContaE(entidad, funcion, data, desc = ''): Observable<any> {
    const obj = {
      entidad,
      funcion,
      data
    };
    // this.headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   UserToken: localStorage.getItem('key'),
    // });


    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.globalService.getBearerToken())
      .set('UserToken', localStorage.getItem('key'));

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'contae/model?d=' + desc, json, { headers: this.headers });
  }

  public modelMasiveContaE(entidad, funcion, data, desc = ''): Observable<any> {
    const obj = {
      entidad,
      funcion,
      data
    };
    // this.headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   UserToken: localStorage.getItem('key'),
    // });


    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.globalService.getBearerToken())
      .set('UserToken', localStorage.getItem('key'));

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'payroll/modelMasive?d=' + desc, json, { headers: this.headers });
  }

  public modelContaEPayroll(entidad, funcion, data, desc = ''): Observable<any> {
    const obj = {
      entidad,
      funcion,
      data
    };
    // this.headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   UserToken: localStorage.getItem('key'),
    // });


    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.globalService.getBearerToken())
      .set('UserToken', localStorage.getItem('key'));

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'payroll/model?d=' + desc, json, { headers: this.headers });
  }

  public modelContaEVaultHistory(entidad, funcion, data, desc = ''): Observable<any> {
    const obj = {
      entidad,
      funcion,
      data
    };
    // this.headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   UserToken: localStorage.getItem('key'),
    // });


    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.globalService.getBearerToken())
      .set('UserToken', localStorage.getItem('key'));

    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'vaultHistory/model?d=' + desc, json, { headers: this.headers });
  }

  public GenerateprintRepresentation(documents, isIncome): Observable<any> {
    const obj = {
      documents: documents,
      isIncome: isIncome,
      UserToken: this.globalService.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Invoice/GenerateCFDIprintRepresentation', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public UloadCoupleFiles(TransacToken, fiXML, fiPDF): Observable<any> {
    const formData = new FormData();
    const UserToken = localStorage.getItem('key');
    if (fiXML != null && fiXML != undefined) { formData.append('XML_File', fiXML.file.rawFile); }
    if (fiPDF != null && fiPDF != undefined) { formData.append('PDF_File', fiPDF.file.rawFile); }

    return this.http.post<any>(this.urlContaE + 'api/Invoice/Invoice_Validate?UserToken=' + UserToken + '&TransacToken=' + TransacToken, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });

  }

  // Nuevos Servicios Settings

  public PacSimple_Is_Active(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE + 'api/Services/PacSimple_Is_Active', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  // Servicios para conocer Si es Premium

  public Module_Access(Module): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 45,
      data: {
        Module: Module
      }
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Home/Module_Access', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public Menu_Settings(Id_Menu): Observable<any> {
    const obj = {
      entidad: "User",
      funcion: 29,
      data: {
        Id_Menu: Id_Menu
      }
    };

    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlSSO + 'app/sso?d=Home/Menu_Settings', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public async getJWTToken(lt: string): Promise<any> {

    const json = JSON.stringify({
      enviroment: environment.Ambiente,
      LoginToken: lt,
      appToken: environment.AppToken
    });

    const myHeaders = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    };

    const response = this.http.post<any>(this.urlSSO + 'Authenticate/GetLoginToken', json, { headers: myHeaders }).toPromise();
    return response;
  }

}



// WEBPACK FOOTER //
// ./src/app/rest/all.service.ts